<template>
  <div class="app">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component class="view" :is="Component" :key="this.$route.path" v-if="this.$route.meta.keepAlive"/>
      </keep-alive>
      <component class="view" :is="Component" :key="this.$route.path"  v-if="!this.$route.meta.keepAlive"/>
    </router-view>

  </div>
</template>

<script>
export default {
  name: "AppIndex"
}
</script>

<style scoped>

</style>